module.exports = __webpack_public_path__ + "img/4.d20cd53a.png";